import { AxiosResponse } from 'axios';

import { api } from '@/lib/api-client.ts';

import { EnrichedDCConfig } from '@/models/EnrichedPrismicDocuments.ts';
import { PVSProvider } from '@/models/customers/PVSProvider.ts';
import { DataCurPracUser } from '@/models/data-cur/DataCurPracUser.ts';
import { DCUser } from '@/models/doc-cirrus/DCUser.ts';

import { getPVSServiceStrategy } from '@/services/pvsStrategy/strategySelector.ts';

import { getCustomerId } from '@/utils/customer-utils.ts';

export const getUsers = async (
    instance_id: string,
    pvs_provider: PVSProvider
): Promise<DCUser[] | DataCurPracUser[] | undefined> => {
    try {
        const { api_url, params } = getPVSServiceStrategy(pvs_provider).createPvsPractitionersFetch(instance_id);
        const response: AxiosResponse<{ data: DCUser[] }> = await api.get(api_url, {
            headers: { customer_id: getCustomerId() },
            params: params,
        });

        return response.data.data.filter((item: DCUser) => item.sync_state === 'UPTODATE');
    } catch (error) {
        throw new Error(`Error fetching users: ${String(error)}`);
    }
};

export const getUsersFromMultipleInstances = async (
    configs: EnrichedDCConfig[]
): Promise<Record<string, DCUser | DataCurPracUser>> => {
    const promises = await Promise.allSettled(
        configs.map((config) => getUsers(config.instance_id, config.pvs_provider))
    );

    const users: Record<string, DCUser | DataCurPracUser> = {};

    for (const [index, promise] of promises.entries()) {
        const config = configs[index];
        if (promise.status === 'fulfilled' && promise.value) {
            for (const user of promise.value) {
                if (config.pvs_provider === PVSProvider.DOC_CIRRUS) {
                    users[`${user.instance_id}_${(user as DCUser).user_id}`] = user;
                }
                if (config.pvs_provider === PVSProvider.DATA_CUR) {
                    users[`${user.instance_id}_${(user as DataCurPracUser).id}`] = user;
                }
            }
        }
    }

    return users;
};
